import React from "react";
import { cn } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
export default function TheWayconIdentity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section data-section-id="39149" id="the-imperium-ethos" className="dark bg-background py-32 relative overflow-hidden bg-[radial-gradient(circle_at_center,rgba(59,130,246,0.03)_0%,transparent_100%)]">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={ref} className={cn("max-w-[800px] mx-auto text-center transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          <h2 className="text-sm font-bold uppercase tracking-[0.3em] text-foreground/80 mb-12">
            About Imperium Technologies
          </h2>
          <div className="space-y-10 text-foreground">
            <p className="text-2xl md:text-4xl font-medium leading-relaxed tracking-tight">At Imperium Technologies, we define the standard for algorithmic trading. Our mission is to provide retail investors with the same level of <span className="text-primary font-bold drop-shadow-[0_0_12px_rgba(59,130,246,0.5)]" data-ast-id="f:/src/pages/AboutUs/sections/TheWayconIdentity.tsx|sig:jf0dlx" data-ast-start="2246" data-ast-end="2347">precision</span> and institutional-grade tools used by the world's leading financial firms.</p>
            <p className="text-2xl md:text-4xl font-medium leading-relaxed tracking-tight">
              We believe in <span className="text-primary font-bold drop-shadow-[0_0_12px_rgba(59,130,246,0.5)]">transparent performance</span> and <span className="text-primary font-bold drop-shadow-[0_0_12px_rgba(59,130,246,0.5)]">professional‑grade execution</span>. By bridging the gap between complex market dynamics and user-friendly automation, we ensure our clients can scale their wealth with absolute confidence.
            </p>
            <p className="text-2xl md:text-4xl font-medium leading-relaxed tracking-tight">Built on a foundation of technical excellence and <span className="text-primary font-bold drop-shadow-[0_0_12px_rgba(59,130,246,0.5)]" data-ast-id="f:/src/pages/AboutUs/sections/TheWayconIdentity.tsx|sig:jf0dlx" data-ast-start="3302" data-ast-end="3415">long‑term credibility</span>, Imperium is more than a algorithm - it is your partner in the global markets.</p>
          </div>
        </div>
      </div>
    </section>;
}